function pagination() {
  const products_on_page = document.getElementById('product-grid'),
      load_more_btn = document.getElementsByClassName('load-more_btn')[0],
      load_more_wrapper = document.getElementsByClassName('collection__load-more')[0];
      
      if(load_more_btn) {
        load_more_btn.addEventListener('click', () => {
          loadMoreProducts();
        });
      }

  let next_url = products_on_page.dataset.nextUrl;

  async function getNextPage() {
    try {
      let res = await fetch(next_url);
      return await res.text();
    } catch (error) {
    }
  }

  async function loadMoreProducts() {
    load_more_wrapper.style.display = 'none';
    let nextPage = await getNextPage();

    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

    const productgrid = nextPageDoc.getElementById('product-grid');
    const new_products = productgrid.getElementsByClassName('grid__item');
    const new_url = productgrid.dataset.nextUrl;
    if (new_url) {
      load_more_wrapper.style.display = 'flex';
    }
    next_url = new_url;

    for (let i = 0; i < new_products.length; i++) {
      let single_product = new_products[i].cloneNode(true);
      products_on_page.appendChild(single_product);
    }
  }
}

pagination();